module.exports = __webpack_public_path__ + "static/media/setting_selected.981c803f.svg";